import { LazyModule, LazyAction, LazyImport, createLazyComponent } from 'owa-bundling';

const lazyModule = new LazyModule(
    () => import(/* webpackChunkName: "CalendarBoardEditor" */ './lazyIndex')
);

export const lazyOpenBoardEditorDialog = new LazyAction(lazyModule, m => m.openBoardEditorDialog);

export const BoardEditorDialog = createLazyComponent(lazyModule, m => m.BoardEditorDialog);

export const lazyIsBoardEditorOpen = new LazyImport(lazyModule, m => m.isBoardEditorOpen);

// NOTE: these non-lazy actions are for subscription purposes only
export { onOpenBoardEditor, onCloseBoardEditor } from './viewstate/notificationActions';
